import "../../assets/css/modal.css";
import "../../assets/css/custom.css";
import { useEffect, useRef, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { IoMdCloseCircle } from "react-icons/io";
import { BorderDelete } from "../../api/border/BorderApi";

export default function DeleteModal({ isOpen, onClose, deleteId }) {
  if (!isOpen) return null;
  const history = useHistory();

  const handleDelete = async (deleteId) => {
    try {
      const resp = await BorderDelete(deleteId);

      if (resp.status === 200) {
        history.push("/border");
      }
    } catch (error) {
      console.log("삭제 실패", error);
      return;
    }
  };

  return (
    <div className="modal-mobile-overlay" onClick={onClose}>
      <div
        style={{
          backgroundColor: `white`,
          // height: `200px`,
          width: `300px`,
          padding: `20px`,
          borderRadius: `8px`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div>
          <div
            style={{
              display: `flex`,
              justifyContent: `center`,
              color: `red`,
            }}
          >
            <IoMdCloseCircle size={30} />
          </div>
          <div
            style={{
              display: `flex`,
              width: `100%`,
              justifyContent: `center`,
              alignItems: `center`,
              marginTop: `10px`,
              fontWeight: `800`,
            }}
          >
            정말 삭제하시겠습니까?
          </div>
          <div
            style={{
              display: `flex`,
              justifyContent: `space-between`,
              marginTop: `10px`,
            }}
          >
            <div
              onClick={() => handleDelete(deleteId)}
              style={{
                backgroundColor: `blue`,
                display: `flex`,
                justifyContent: `center`,
                alignItems: `center`,
                width: `100%`,
                height: `40px`,
                borderRadius: `8px`,
                fontWeight: `800`,
                fontSize: `16px`,
                color: `white`,
                cursor: `pointer`,
              }}
            >
              예
            </div>
            <div
              style={{
                width: `20px`,
              }}
            ></div>
            <div
              onClick={onClose}
              style={{
                backgroundColor: `red`,
                display: `flex`,
                justifyContent: `center`,
                alignItems: `center`,
                width: `100%`,
                height: `40px`,
                borderRadius: `8px`,
                fontWeight: `800`,
                fontSize: `16px`,
                color: `white`,
                cursor: `pointer`,
              }}
            >
              아니오
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
